import axios from "axios";
import React, { useEffect, useState } from "react";
import { DeletedFilter, RestoreAction } from "../../components/common/DeletedFilter";
import {
  INCOME_CATEGORY_LIST,
  INCOME_CATEGORY_DELETE,
  INCOME_CATEGORY_RESTORE,
} from "../../routes/routes";
import { PAGINATE } from "../../constant/constant";
import { toast } from "react-toastify";
import { NoDataFound, Pagination } from "../../components/Utils";
import Loader from "../../components/common/Loader";
import { Link, useNavigate } from "react-router-dom";
import { Modal } from "react-bootstrap";
import { usePermission } from "../../hooks/usePermission";
import StickyTable from "../../components/common/StickyTable";

const IncomeCategoryList = () => {
  const { hasPermission } = usePermission();
  const [data, setData] = useState([]);
  const [paginator, setPaginator] = useState({});
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [refresh, setRefresh] = useState(false);
  const [confirmation, setConfirmation] = useState({});
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [filter, setFilter] = useState([]);
  const [deletedFilter, setDeletedFilter] = useState("no");

  const navigate = useNavigate();

  const HandleDelete = async (id) => {
    try {
      axios
        .delete(INCOME_CATEGORY_DELETE + id)
        .then((res) => {
          if (res.status === 200 && res.data.success) {
            toast.success("Income Category deleted successfully");
            setRefresh((prevRefresh) => !prevRefresh);
          }
        })
        .catch((err) => {
          if (err.response && err.response.status === 422) {
            toast.error(err.response.data.msg);
          } else {
            toast.error("Something went wrong");
          }
        });
    } catch (error) {
      console.error(error);
    }
  };


  const HandleRestore = async (recordId) => {
    try {
      axios
        .post(INCOME_CATEGORY_RESTORE + recordId)
        .then((res) => {
          if (res.status === 200 && res.data.success) {
            toast.success("Restored successfully");
            setRefresh((prevRefresh) => !prevRefresh);
          } else {
            toast.error(res?.data?.msg || "Failed to restore");
          }
        })
        .catch((err) => {
          toast.error(err.response?.data?.msg || "Failed to restore");
        });
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    setLoading(true);
    axios
      .get(INCOME_CATEGORY_LIST, {
        params: {
          type: PAGINATE,
          page: page,
          perPage: perPage,
          ...filter,
          deleted: deletedFilter,
        },
      })
      .then((response) => {
        if (response.status === 200 && response.data.success) {
          setData(response.data.data.income_category);
          setPaginator({
            prev: response.data.data.prev != "",
            next: response.data.data.next != "",
            total: response.data.data.total,
            current: response.data.data.current_page,
            last: response.data.data.last_page,
          });
        }
      })
      .finally(() => {
        setLoading(false);
      });
  }, [page, filter, perPage, refresh, deletedFilter]);

  return (
    <div className="content-wrapper">
      <div className="container-fluid p-0 mt-0 mb-2">
        <div className="col-lg-12">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <h5 className="page-title">Income Category</h5>
              <ol className="breadcrumb">
                <li>
                  <div className="breadcrumb_f">
                    <div>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="50"
                        height="50"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#212b39"
                        strokeWidth="1"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                        <polyline points="9 22 9 12 15 12 15 22"></polyline>
                      </svg>
                    </div>
                    <div>
                      <Link to={"/dashboard"}>
                        <span>Dashboard</span>
                      </Link>
                    </div>
                  </div>
                </li>
                <li>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="50"
                    height="50"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#212b39"
                    strokeWidth="1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M9 18l6-6-6-6" />
                  </svg>
                </li>
                <li>
                  <span className="active_breadcrumb">
                    Income Category List
                  </span>
                </li>
              </ol>
            </div>
            <div className="col-lg-6">
              <div className="pt-btn">
                {hasPermission("income-category-create") && (
                  <Link to={"/create/income-category"}>
                    <button
                      type="button"
                      className="btn rounded-pill btn-primary ibutton"
                    >
                      <span className="tf-icons bx bx-plus"></span>&nbsp; Add
                    </button>
                  </Link>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="flex-grow-1">
        <div className="card icard sticky-table-card">
          <div className="container-fluid f_containter">
            <div className="row mb-4">

              <div className="col-md-3">
                <div className="mb-3">
                  <label className="form-label" htmlFor="search">
                    Search
                  </label>
                  <input
                    type="text"
                    className="form-control hide-arrow"
                    id="search"
                    placeholder="Search by Name"
                    onChange={(e) =>
                      setFilter({ ...filter, search: e.target.value })
                    }
                  />
                </div>
              </div>
            
              <DeletedFilter
                value={deletedFilter}
                onChange={(value) => {
                  setPage(1);
                  setDeletedFilter(value);
                }}
              />
            </div>
          </div>

          {data.length > 0 && (
            <Pagination
              paginator={paginator}
              page={(no) => setPage(no)}
              perPage={perPage}
              setPerPage={setPerPage}
            />
          )}
          <StickyTable refreshDeps={[data, loading]}>
            <table className="table table-striped itable">
              <thead>
                <tr>
                  <th>Sl. No.</th>
                  <th>Name</th>
                  <th>Amount</th>
                  <th style={{ textAlign: "center", width: "10%" }}>Action</th>
                </tr>
              </thead>
              <tbody className="table-border-bottom-0">
                {loading ? (
                  <Loader loading={loading} colspan="3" />
                ) : data.length > 0 ? (
                  data.map((item, i) => (
                    <tr key={i}>
                      <td>{item?.sno}</td>
                      <td>{item?.name}</td>
                      <td>{item?.amount}</td>
                      <td style={{ textAlign: "right" }}>{deletedFilter === "yes" ? (
                        hasPermission("income-category-edit") && (<RestoreAction
                          onClick={() => {
                            setConfirmationModal(true);
                            setConfirmation({
                              message: "Are you sure you want to restore?",
                              fn: () => HandleRestore(item?.id),
                            });
                          }}
                        />)
                      ) : (
                        <>
                        {hasPermission("income-category-edit") && (
                          <Link to={`/income-category/${item.id}/edit`}>
                            <button
                              className="badge bg-label-success me-1 border-0"
                              data-bs-toggle="tooltip"
                              title="Edit"
                            >
                              <i className="bx bx-pencil"></i>
                            </button>
                          </Link>
                        )}

                        {hasPermission("income-category-delete") &&
                          item?.is_static === 0 && (
                            <button
                              onClick={() => {
                                setConfirmationModal(true);
                                setConfirmation({
                                  message: "Are you sure, you want to delete?",
                                  fn: () => HandleDelete(item?.id),
                                });
                              }}
                              className="badge bg-label-danger me-1 border-0"
                              data-bs-toggle="tooltip"
                              title="Delete"
                            >
                              <i className="bx bx-trash"></i>
                            </button>
                          )}
                      </>
                      )}</td>
                    </tr>
                  ))
                ) : (
                  <NoDataFound colspan="4" message="No Data Found" />
                )}
              </tbody>
            </table>
          </StickyTable>
          {data.length > 0 && (
            <Pagination
              paginator={paginator}
              page={(no) => setPage(no)}
              perPage={perPage}
              setPerPage={setPerPage}
            />
          )}
        </div>
      </div>

      <Modal
        show={confirmationModal}
        size="sm"
        centered
        onHide={() => setConfirmationModal(false)}
        backdrop="static"
      >
        <Modal.Header closeButton className="no-border"></Modal.Header>
        <Modal.Body className="idel_popup">
          <div className="icon_holder">
            <div className="pop_del_icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="50"
                height="50"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#CF2030"
                strokeWidth="1"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <polyline points="3 6 5 6 21 6"></polyline>
                <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                <line x1="10" y1="11" x2="10" y2="17"></line>
                <line x1="14" y1="11" x2="14" y2="17"></line>
              </svg>
            </div>
          </div>
          <h6 className="text-center modal_title">{confirmation?.message}</h6>
          <div className="text-center">
            <button
              onClick={() => {
                setConfirmationModal(false);
                setConfirmation({});
              }}
              className="btn btn-danger btn-sm me-2 iclose_btn"
            >
              No
            </button>
            <button
              onClick={() => {
                confirmation.fn();
                setConfirmationModal(false);
                setConfirmation({});
              }}
              className="btn btn-success btn-sm isubmit_button"
            >
              Yes
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default IncomeCategoryList;
